export default __webpack_public_path__ + "static/media/nsdl_payment_bank.257620e1.png";